import { createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickContractsAvailable, getOneClickInvoiceSelected } from '../../selectors/one-click-contract.selector';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import {_safe} from '@ordersnproducts/modules/shared/utils/safe-get.method';

const getContractSelected = (index: number) =>
  createSelector(
    getOneClickSelectedOrder,
    getOneClickContractsAvailable(index),
    getOneClickInvoiceSelected(index),
    (order, contract, invoice) => ({ order, contract, invoice }),
  );

export class OneClickContractProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getContractSelected(this.mapItem['index'])).pipe(
      map(({ order, contract, invoice }) => {
        const contractSelected = _safe(() => order.items[this.mapItem['index']].agreementItem.agreementItemId);
        if (invoice) {
          // Has invoice
          return invoice.salesDocumentCode;
        } else if (contract) {
          // Has contract
          const equivalent = contract.find(
            contractAvailable =>
              !!contractAvailable &&
              !!contractAvailable.salesDocumentItemId &&
              contractAvailable.salesDocumentItemId === contractSelected,
          );
          return equivalent.salesDocumentCode;
        } else {
          return null;
        }
      }),
    );
  }
}
